<div class="raceOff-list-item p-3" role="button">
  <div class="d-flex">
    <h2 class="flex-grow-1">
      <span>{{ raceOff.name }}</span>
    </h2>

    <div class="chip-list">
      <div *ngIf="!raceOff.gpx" class="chip danger">⚠️ Gpx manquant</div>
      <div
        class="chip"
        [ngClass]="{
          default: intervalToRace <= 0,
          success: intervalToRace > 0 && intervalToRace > intervalSoonLimit,
          warning: intervalToRace > 0 && intervalToRace <= intervalSoonLimit,
          danger: intervalToRace > 0 && intervalToRace <= intervalImminentLimit
        }"
      >
        <strong>
          {{ intervalToRacePrefix }}
          {{ intervalToRaceLabel }}
        </strong>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-start mb-2">
    <span class="_distance">{{ raceOff.distance }} km</span>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="d-flex flex-column align-items-start">
        <span class="_int" i18n>Date & Heure de départ</span>
        <div *ngIf="raceOff?.status === 'canceled'; else ddate">
          <div class="chip-list">
            <div class="chip disabled">{{ raceOff?.status | translate }}</div>
          </div>
        </div>
        <ng-template #ddate>
          <div class="d-flex">
            <span>{{ raceOff.date | date : "EEE dd MMM y" }} </span>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col-md-5 col-lg-4">
      <div class="d-flex flex-column flex-grow-1 align-items-start">
        <span class="_int" i18n>Lieu de départ</span>
        <span>{{ raceOff.locality }} </span>
      </div>
    </div>
    <div class="col-md-3 col-lg-2">
      <div class="d-flex flex-column align-items-start">
        <span class="_int" i18n>Dénivelé +</span>
        <span>{{ raceOff.ascendingElevation || "--" }}mD+</span>
      </div>
    </div>
    <div class="col-md-3 col-lg-2">
      <div class="d-flex flex-column align-items-start">
        <span class="_int" i18n>Dénivelé -</span>
        <span>{{ raceOff.negativeElevation || "--" }}mD-</span>
      </div>
    </div>
  </div>
</div>
